const text = {
  en: {
        // Header
        title: "Reports Analytics Center",
        subtitle: "Comprehensive reporting and analytics dashboard",

        // Stats
        totalReports: "Total Reports",
        generatedThisMonth: "Generated This Month",
        totalDownloads: "Total Downloads",
        avgGenerationTime: "Avg Generation Time",
        totalEmployees: "Total Employees",
        activeEmployees: "Active Employees",
        avgAttendanceRate: "Avg Attendance Rate",
        recentHires: "Recent Hires",

        // Categories
        allReports: "All Reports",
        performance: "Performance",
        payroll: "Payroll",
        attendance: "Attendance",
        recruitment: "Recruitment",
        training: "Training",
        budget: "Budget",

        // Category Descriptions
        allReportsDesc: "Complete overview of all available reports",
        performanceDesc: "Employee KPIs and productivity metrics",
        payrollDesc: "Salary, benefits, and financial summaries",
        attendanceDesc: "Leave patterns and attendance analytics",
        recruitmentDesc: "Hiring metrics and talent acquisition",
        trainingDesc: "Learning and development progress",
        budgetDesc: "Financial planning and budget analysis",

        // Controls
        searchPlaceholder: "Search reports, tags, or authors...",
        newestFirst: "Newest First",
        oldestFirst: "Oldest First",
        mostDownloaded: "Most Downloaded",
        highestRated: "Highest Rated",
        grid: "Grid",
        list: "List",
        filters: "Filters",

        // Report Actions
        download: "Download",
        share: "Share",
        view: "View",
        edit: "Edit",
        delete: "Delete",

        // Report Details
        author: "Author",
        lastGenerated: "Last Generated",
        fileSize: "File Size",
        format: "Format",
        estimatedReadTime: "Estimated Read Time",
        downloads: "Downloads",
        shares: "Shares",
        rating: "Rating",

        // Status
        ready: "Ready",
        generating: "Generating",
        error: "Error",

        // Email Modal
        shareReport: "Share Report",
        sendReportViaEmail: "Send report via email",
        recipients: "Recipients",
        addRecipient: "Add recipient...",
        subject: "Subject",
        message: "Message",
        addPersonalMessage: "Add a personal message...",
        includeAttachment: "Include report as attachment",
        sendNotification: "Send Notification",
        sendWithAttachment: "Send with Attachment",
        sending: "Sending...",
        cancel: "Cancel",

        // Messages
        reportSentSuccess: "Report sent successfully!",
        reportDownloadSuccess: "Report downloaded successfully!",
        reportGenerateSuccess: "New report generated successfully!",
        errorSendingReport: "Failed to send report via email.",
        errorDownloadingReport: "Failed to download report.",
        errorGeneratingReport: "Failed to generate report.",
        userInfoNotAvailable: "User information not available",
        loading: "Loading...",
        noReportsFound: "No reports found",

        // Time
        min: "min",
        today: "today",
        yesterday: "yesterday",
        daysAgo: "days ago",

        // Report Titles
        reportTitles: {
          "Employee Performance Q4 2025": "Employee Performance Q4 2025",
          "Monthly Payroll Summary - December 2025": "Monthly Payroll Summary - December 2025",
          "Weekly Attendance Analytics Dashboard": "Weekly Attendance Analytics Dashboard",
          "Recruitment & Hiring Analysis - 2025": "Recruitment & Hiring Analysis - 2025",
          "Training & Development Progress Report": "Training & Development Progress Report",
          "Budget Analysis - December 2025": "Budget Analysis - December 2025",
        },

        reportDescriptions: {
          "Comprehensive performance analysis for 32 active employees including attendance patterns, productivity metrics, and departmental distribution.":
            "تحليل شامل للأداء لـ 32 موظف نشط يشمل الحضور والإنتاجية والتوزيع الإداري.",
          "Detailed payroll breakdown for 32 employees with total disbursement of $244,000.":
            "تفصيل الرواتب لـ 32 موظف بإجمالي 244,000 دولار.",
          "Current week attendance analysis covering 64 attendance records with 1 present, 67 absent entries.":
            "تحليل حضور الأسبوع الحالي يغطي 64 سجل حضور مع 1 حاضر و67 غائب.",
          "Recent hiring trends with 5 new employees in the last 3 months. Includes hiring patterns, department distribution, and onboarding metrics.":
            "اتجاهات التوظيف الأخيرة مع 5 موظفين جدد خلال آخر 3 شهور تشمل أنماط التوظيف والتوزيع الإداري ومقاييس الإلحاق.",
          "Comprehensive overview of employee training programs, completion rates, and skill development initiatives for 32 active employees.":
            "نظرة شاملة على برامج تدريب الموظفين ومعدلات الإكمال ومبادرات تطوير المهارات لـ 32 موظف نشط.",
          "Financial planning and budget allocation analysis with total HR budget of $244,000 and department-wise breakdown.":
            "تحليل التخطيط المالي وتوزيع الميزانية بإجمالي ميزانية الموارد البشرية 244,000 دولار والتوزيع حسب الإدارات.",
        },

        authors: {
          "HR Department": "HR Department",
          "Finance Team": "Finance Team",
          "Operations Manager": "Operations Manager",
          "Talent Acquisition": "Talent Acquisition",
          "L&D Department": "L&D Department",
          "Finance Department": "Finance Department",
        },

        tags: {
          Q4: "Q4",
          Performance: "Performance",
          Analytics: "Analytics",
          KPI: "KPI",
          December: "December",
          Salary: "Salary",
          Benefits: "Benefits",
          Finance: "Finance",
          Weekly: "Weekly",
          "Real-time": "Real-time",
          Hiring: "Hiring",
          "2025": "2025",
          Onboarding: "Onboarding",
          Development: "Development",
          Skills: "Skills",
          Learning: "Learning",
          Planning: "Planning",
          Analysis: "Analysis",
        },
      },

      ar: {
        // Header
        title: "مركز تحليلات التقارير",
        subtitle: " تحكم شاملة للتقارير والتحليلات",

        // Stats
        totalReports: "إجمالي التقارير",
        generatedThisMonth: "تم إنشاؤها هذا الشهر",
        totalDownloads: "إجمالي التنزيلات",
        avgGenerationTime: "متوسط وقت الإنشاء",
        totalEmployees: "إجمالي الموظفين",
        activeEmployees: "الموظفون النشطون",
        avgAttendanceRate: "متوسط نسبة الحضور",
        recentHires: "التوظيفات الحديثة",

        // Categories
        allReports: "جميع التقارير",
        performance: "الأداء",
        payroll: "الرواتب",
        attendance: "الحضور",
        recruitment: "التوظيف",
        training: "التدريب",
        budget: "الميزانية",

        // Category Descriptions
        allReportsDesc: "نظرة شاملة على جميع التقارير المتاحة",
        performanceDesc: "مؤشرات الأداء الرئيسية وقياسات الإنتاجية",
        payrollDesc: "الرواتب والمزايا والملخصات المالية",
        attendanceDesc: "أنماط الإجازات وتحليلات الحضور",
        recruitmentDesc: "مقاييس التوظيف واكتساب المواهب",
        trainingDesc: "تقدم التعلم والتطوير",
        budgetDesc: "التخطيط المالي وتحليل الميزانية",

        // Controls
        searchPlaceholder: "البحث في التقارير أو الوسوم أو المؤلفين...",
        newestFirst: "الأحدث أولاً",
        oldestFirst: "الأقدم أولاً",
        mostDownloaded: "الأكثر تنزيلاً",
        highestRated: "الأعلى تقييماً",
        grid: "شبكة",
        list: "قائمة",
        filters: "الفلاتر",

        // Report Actions
        download: "تنزيل",
        share: "مشاركة",
        view: "عرض",
        edit: "تعديل",
        delete: "حذف",

        // Report Details
        author: "المؤلف",
        lastGenerated: "آخر إنشاء",
        fileSize: "حجم الملف",
        format: "التنسيق",
        estimatedReadTime: "وقت القراءة المقدر",
        downloads: "التنزيلات",
        shares: "المشاركات",
        rating: "التقييم",

        // Status
        ready: "جاهز",
        generating: "جاري الإنشاء",
        error: "خطأ",

        // Email Modal
        shareReport: "مشاركة التقرير",
        sendReportViaEmail: "إرسال التقرير عبر البريد الإلكتروني",
        recipients: "المستلمون",
        addRecipient: "إضافة مستلم...",
        subject: "الموضوع",
        message: "الرسالة",
        addPersonalMessage: "إضافة رسالة شخصية...",
        includeAttachment: "تضمين التقرير كمرفق",
        sendNotification: "إرسال إشعار",
        sendWithAttachment: "إرسال مع المرفق",
        sending: "جاري الإرسال...",
        cancel: "إلغاء",

        // Messages
        reportSentSuccess: "تم إرسال التقرير بنجاح!",
        reportDownloadSuccess: "تم تنزيل التقرير بنجاح!",
        reportGenerateSuccess: "تم إنشاء تقرير جديد بنجاح!",
        errorSendingReport: "فشل إرسال التقرير عبر البريد الإلكتروني.",
        errorDownloadingReport: "فشل تنزيل التقرير.",
        errorGeneratingReport: "فشل إنشاء التقرير.",
        userInfoNotAvailable: "معلومات المستخدم غير متوفرة",
        loading: "جاري التحميل...",
        noReportsFound: "لم يتم العثور على تقارير",

        // Time
        min: "دقيقة",
        today: "اليوم",
        yesterday: "أمس",
        daysAgo: "أيام مضت",

        reportTitles: {
          "Employee Performance Q4 2025": "أداء الموظفين الربع الرابع 2025",
          "Monthly Payroll Summary - December 2025": " الرواتب الشهري - ديسمبر 2025",
          "Weekly Attendance Analytics Dashboard": " تحليلات الحضور الأسبوعية",
          "Recruitment & Hiring Analysis - 2025": "تحليل التوظيف والتعيين - 2025",
          "Training & Development Progress Report": "تقرير تقدم التدريب والتطوير",
          "Budget Analysis - December 2025": "تحليل الميزانية - ديسمبر 2025",
        },

        reportDescriptions: {
          "Comprehensive performance analysis for 32 active employees including attendance patterns, productivity metrics, and departmental distribution.":
            "تحليل شامل للأداء لـ 32 موظف نشط يشمل الحضور والإنتاجية والتوزيع الإداري.",
          "Detailed payroll breakdown for 32 employees with total disbursement of $244,000.":
            "تفصيل الرواتب لـ 32 موظف بإجمالي 244,000 دولار.",
          "Current week attendance analysis covering 64 attendance records with 1 present, 67 absent entries.":
            "تحليل حضور الأسبوع الحالي يغطي 64 سجل حضور مع 1 حاضر و67 غائب.",
          "Recent hiring trends with 5 new employees in the last 3 months. Includes hiring patterns, department distribution, and onboarding metrics.":
            "اتجاهات التوظيف الأخيرة خلال آخر 3 شهور.",
          "Comprehensive overview of employee training programs, completion rates, and skill development initiatives for 32 active employees.":
            "نظرة شاملة على برامج التدريب وتطوير المهارات.",
          "Financial planning and budget allocation analysis with total HR budget of $244,000 and department-wise breakdown.":
            "تحليل التخطيط المالي وتوزيع الميزانية.",
        },

        authors: {
          "HR Department": "إدارة الموارد البشرية",
          "Finance Team": "فريق المالية",
          "Operations Manager": "مدير العمليات",
          "Talent Acquisition": "اكتساب المواهب",
          "L&D Department": "إدارة التعلم والتطوير",
          "Finance Department": "إدارة المالية",
        },

        tags: {
          Q4: "الربع الرابع",
          Performance: "الأداء",
          Analytics: "التحليلات",
          KPI: "مؤشرات الأداء",
          December: "ديسمبر",
          Salary: "الراتب",
          Benefits: "المزايا",
          Finance: "المالية",
          Weekly: "أسبوعي",
          "Real-time": "فوري",
          Hiring: "التوظيف",
          "2025": "2025",
          Onboarding: "الإلحاق",
          Development: "التطوير",
          Skills: "المهارات",
          Learning: "التعلم",
          Planning: "التخطيط",
          Analysis: "التحليل",
        },
      },
    };

export default text;